import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SponsorRegistrationP1 from "./components/Page1";
import SponsorRegistrationP2 from "./components/Page2";
import SponsorRegistrationP3 from "./components/Page3";
import { alreadyRegApplication, getOneContractFarmingDetails } from "../../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import RegistrationStatus from "./components/RegistrationStatus";
import MBAFormJ from "../../MarketingBoard/Registration/components/MBAFormJ";

const SponsorRegistrationIndex = () => {
  const navigate = useNavigate();
  const token = useSelector((state: any) => state.auth.token);
  const [step, setStep] = useState<number>(1);
  const [applicationAllowed, setApplicationAllowed] = useState(false);
  const [applicationData, setApplicationData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [viewingExistingApp, setViewingExistingApp] = useState(false);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
 const location =useLocation()
 const applicationIdMBMD=location?.state?.applicationId
 const [applicationStatus, setApplicationStatus] = useState("")
 const [applicationDataInfo, setApplicationDataInfo] = useState<any>(null);
 const [tenureDate, setTenureDate] = useState("")

  const [paymentData, setPaymentData] = useState({
    fruitsFee: 0,
    othersFee: 0,
    totalFee: 0,
    selectedOthersCount: 0,
    anyFruitsSelected: false,
    selectedAPMCsCount: 0,
  });

  const handleNext = (data?: any): void => {
    if (data) {
      setPaymentData(data);
    }
    if (step < 3) setStep(step + 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleBack = (): void => {
    if (step > 1) setStep(step - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleViewApplication = (): void => {
    setViewingExistingApp(true);
    setStep(1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCloseViewApplication = (): void => {
    setViewingExistingApp(false);
    setStep(1);
  };

  const applicationExist = async () => {
    setLoading(true);
    try {
      const res = await alreadyRegApplication(token);
      if (res?.success === true) {
        setApplicationAllowed(res.data?.isAllowed || res.data?.paymentStatus === "PENDING" || res.data?.status === "reject");
       
        setApplicationData(res?.data);
        setApplicationStatus(res?.data?.status)
        setTenureDate(res?.data?.Sponsor_Reg_To)
       
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    applicationExist();
  }, [token]);

    const applicationIdd = applicationData?.applicationId
          const fetchApplicationData = async (applicationIdd: string) => {
        try {
          setLoading(true);
          const result = await getOneContractFarmingDetails(applicationIdd, token);
    
          if (result.success && result.data) {
            setApplicationDataInfo(result.data);
            // setRemarks(result.data?.Remark || "");
          } else {
            toast.warning("No previous data found", { position: "top-right" });
          }
        } catch (error) {
         
          toast.error("Failed to load application data", { position: "top-right" });
        } finally {
          setLoading(false);
        }
      };
    
    
    
      useEffect(() => {
        if (applicationIdd) {
          fetchApplicationData(applicationIdd);
        }
      }, [applicationIdd]);

  return (
    <div>
      {roleIdentifier==="SPO" &&
      (<div>
              <div
        className="position-fixed page-wrapper start-0 end-0 z-3 border-bottom"
        style={{
          backgroundColor: "#f8f9fa",
        }}
      >
        <div className=" w-100">
          <div className="m-3 d-flex justify-content-center align-items-center">
            {/* Step 1 */}
            <div
              className="d-flex flex-column align-items-center gap-1 "
              style={{ minWidth: "80px" }}
            >
              <div
                className="rounded-circle d-flex justify-content-center align-items-center"
                style={{
                  height: "50px",
                  width: "50px",
                  backgroundColor: step > 1 ? "#1b84ff" : "white",
                  border:
                    step === 1 ? "2px solid #1b84ff" : "1px solid lightblue",
                  color: step > 1 ? "white" : "#0d6efd",
                  fontSize: "1.5rem",
                }}
              >
                {step > 1 ? (
                  <i className="feather feather-check text-white"></i>
                ) : (
                  1
                )}
              </div>
              <p>Fill Forms</p>
            </div>

            <div
              className="bg-dark"
              style={{
                height: "2px",
                width: "200px",
                position: "relative",
                top: "-10px",
              }}
            ></div>

            {/* Step 2 */}
            <div
              className="d-flex flex-column align-items-center gap-1 "
              style={{ minWidth: "80px" }}
            >
              <div
                className="rounded-circle d-flex justify-content-center align-items-center"
                style={{
                  height: "50px",
                  width: "50px",
                  backgroundColor: step > 2 ? "#1b84ff" : "white",
                  border:
                    step === 2 ? "2px solid #1b84ff" : "1px solid lightblue",
                  color: step > 2 ? "white" : "#0d6efd",
                  fontSize: "1.5rem",
                }}
              >
                {step > 2 ? (
                  <i className="feather feather-check text-white"></i>
                ) : (
                  2
                )}
              </div>
              <p>Payment fee</p>
            </div>
          </div>
        </div>
      </div>

      {/* Spacer for Fixed Header */}
      <div style={{ height: "80px" }}></div>
      </div>)}

      {loading ? (
        <div className="page-wrapper d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ):applicationStatus==="reject" ? (
        <div className="page-wrapper">
          <div className="pb-4"></div>
          <MBAFormJ applicationId={applicationData?.applicationId} applicationDataInfo={applicationDataInfo} valCalledIn={"sponsorFill"} />
          </div>
      )
      : applicationAllowed && applicationData && !viewingExistingApp ? (
        <div className="page-wrapper">
          {step === 1 && (
            <SponsorRegistrationP1
              onNext={handleNext}
              // applicationData={applicationData}
              applicationId={applicationData?.applicationId}
              canOnlyView={false}
              couchId={applicationData?.applicationDataId}
            />
          )}
          {step === 2 && (
            <SponsorRegistrationP2
              onBack={handleBack}
              onNext={handleNext}
              paymentData={paymentData}
              applicationData={applicationData}
              
            />
          )}
        </div>
      ) : viewingExistingApp ? (
        <div className="page-wrapper">
          {step === 1 && (
            <SponsorRegistrationP1
              onNext={handleNext}
              // applicationData={applicationData}
              applicationId={applicationData?.applicationId}
              canOnlyView={true}
              couchId={applicationData?.applicationDataId}
            />
          )}
          <div className="mt-4 mb-4 text-center">
            <button 
              className="btn btn-secondary"
              onClick={handleCloseViewApplication}
            >
              Back to Applications
            </button>
          </div>
        </div>
      ) : roleIdentifier==="MBMD" ? 
      (<div className="page-wrapper">
        <SponsorRegistrationP1
              onNext={handleNext}
              // applicationData={applicationData}
              applicationId={applicationIdMBMD}
              canOnlyView={true}
              couchId={applicationData?.applicationDataId}
            />
            </div>
      ):applicationStatus==="approved"?
      (<div className="page-wrapper text-center">
        <div style={{ height: "80px" }}></div>
        <h2>You Registration Application has Already Approved</h2>
          <p className="mt-3 fs-16">Your application will remain valid for the selected time period <span className="fw-bold">{tenureDate}</span>. As long as your Registration is Active. </p>
      </div>)
      :
      (
        <div className="page-wrapper text-center">
          <div style={{ height: "80px" }}></div>
          <h2>You have Already filled this application</h2>
          <p className="mt-3 fs-16">Go to My Application in Registration for Status</p>
          <button 
            className="btn btn-info"
            onClick={handleViewApplication}
          >
            View Application
          </button>
        </div>
      )}
    
      <ToastContainer position="top-left" autoClose={3000} />
    </div>
  );
};

export default SponsorRegistrationIndex;